export const directors = [
    {
        id: 1,
        name: 'Mr. Onoja Atta Onoja',
        image: '/images/onoja.jfif',
        role: 'PRESIDENT',
        description: `Mr. Onoja Atta Onoja is a dynamic individual with over 20 years cooperate
                        experience, 15 of which are at senior management levels spanning 
                        Shipping, Distribution, Advertisement/Marketing and Oil & Gas, 
                        he holds a Masters Degree from the University of Lagos in Business
                         Administration (MBA), Bachelor’s Degree in Adult Education from 
                         the University of Lagos and a diploma in Insurance from the 
                         University of Lagos. He is a well-known apostle of advancing 
                         trade relation within developing countries. He seats on several
                          Boards such as motomedia Africa, Avos Limited, 2 Zero GROUP, 
                          Delight travel Service and the Green foundation Nigeria.
                        He is equally a member of the Lagos chamber of trade and 
                        commerce, an Associate member of the institute of Professional
                        managers and administrators of Nigeria, and Coordinator Nigerians 
                        in the diaspora Caribbean. Mr Onoja has equally served as the
                        Nigerian High commissioner’s representative to Guyana Before 
                        assuming office as the first President for the African Caribbean 
                        Chambers of Trade, Commerce and Industry.
                    `
    },
    {
        id: 2,
        name: 'Ikechukwu Mozie',
        image: '/images/phlip.jfif',
        role: 'Regional Director (Africa)',
        description: `Ikechukwu mozie is appointed Regional Director (Africa), An 
        Experienced Marketing Communications and Public Relations Specialist with
         a demonstrated history of working in the marketing and advertising industry.
          Skilled in Negotiation, Business Strategy, Customer Service Relations, 
          Corporate Policy and Strategic Management. Mr Mozie educational qualifications
           includes Higher National Diploma (HND), Mass Communication Anambra State Polytechnic,
            (now Federal Polytechnic) Oko, Diploma in Management/mini MBA, Strategic Business 
            Management, Marketing and Communication Studies, Int'l Business Management Institute, 
            Berlin Germany and professional qualifications from Advertising Practitioners Council 
            of Nigeria (APCON), Nigeria Institute of Management (NIM), Nigerian Institute of Public 
             Relations (NIPR). Mr Mozie has over 20 years’ 
           experience in the private sector as Chief Executive officer of Emivik Nigeria Limited`
    },
    {
        id: 3,
        name: 'Eric Phillips',
        image: '/images/philips-new.jpg',
        role: 'Regional Director (Caribbean)',
        description: `The recipient of the Golden Arrow of Achievement for Youth Development, 
                      Entrepreneurship, and Community Development, He is also the Chairperson of the 
                      Guyana Reparations Committee and a Vice-Chair of the CARICOM Reparations
                       Commission. Eric is also an Executive Member of the African Cultural & 
                       Development Association (ACDA) and was the first President of the African 
                       Business Roundtable (ABR) in Guyana. Eric Phillips is also a 1990-91 White
                       House Fellow.
                       Eric Phillips has a degree in Chemical Engineering from McMaster University
                       in Ontario, Canada, an MBA in Marketing and International Business from New 
                       York University Stern School of Business, and was also selected as one of 14
                        fast tract MBA/engineers /leaders to spend fourteen months at Stevens
                         Institute of Technology and AT&T Bell Laboratories in the Communications 
                         Training Program (CTP) for Telecommunications Engineering. Eric has been 
                         the Managing Director of AT&T Africa & the Middle East, Vice President of
                          AT&T Network Systems, the Managing Director for AT&T Central Europe 
                          (Ukraine) and the Deputy Director for AT&T Globalization in Belgium, 
                          Europe. He was also a Director of ASC Inc. in London, United Kingdom.
                           Eric spent seven years in South Africa where he was a Director of Africa
                            Union Holdings, he is also a Director for Combination Therapy Medical Solutions 
                            and the Chief Operating Officer for Safika Holdings Pty.`
    },
    {
        id: 7,
        name: 'Brig. Gen. Amb. Dr Wallace W. Williams',
        image: '/images/williams.PNG',
        role: 'Director & Chairman Advisory Board',
        description: `Amb. Dr Wallace W Williams, is the Honorary Consul General for the 
                     Caribbean of Antigua & Barbuda to Nigeria . He has dedicated over 4 decades
                      of his life to forging ties between the people, businesses, Governments and
                       Civil Societies in Africa, Europe, and the Americas in the areas of Tourism,
                        Entertainment, Media, Culture, Education, Entrepreneurship and Youth 
                        Development. Amb Williams Wallace is an Adjunct Professor , Pan Afrikan 
                        Institute Founder/Chairman Afrostar Sudacc- Standard United Digital Afrikan
                         Currency contract . Advisory Board Chairman | Africa International Chamber
                          of Commerce & Industry ( AICCI )`
    },
    {
        id: 4,
        name: 'Dr. Dexter Mark Godfrey Todd',
        image: '/images/todd.jpg',
        role: 'Director (legal)',
        description: `A renowned attorney at law who is admitted to the legal bar in Guyana and
                     Belize. He is an international Professional trainer on peace and security with
                      the International Consulting Cabinet in Geneva and a member of the Peace and
                       Security Advisory Council to Caribbean Nations, MACBAN Corp USA. Dr. Todd 
                       possesses experience in all areas of law and has litigated from admission 
                       to bar to current, over 500 cases. In addition, he is a coach to many young
                        attorneys and law students from both the University of Guyana and Charisma
                         University. To date, Todd holds a Bachelor of Science (BSc) in International
                          Relations from the University of Guyana, a Bachelor of Laws (LL. B) from 
                          the University of Guyana, a Legal Education Certificate (LEC) from the 
                          Hugh Wooding Law School, a Master of Laws in Conflict Resolution (ADR)
                           with Honors from Charisma University, and a Master of Laws in International
                            Business Law with Merit from Cambria University in London. A Master of Science,
                             MSc in Fraud and Risk Management from the University of Salford Manchester,
                            London.
                           He’s a highly qualified attorney who is also a Peace Ambassador, appointed by 
                           WHOMI to the United Nations, and holds the title His Excellency Dr. Dexter Todd.
                             Dr. Todd has done extensive research in peace and security, Investment law, 
                             and Risk management. With his great research in those areas since the year 2017, 
                             Dr. Todd has presented many papers and has been consulted internationally on them.
                             Dr. Todd is a member of Charisma University’s Senate and was appointed in
                              2021 as an Adjunct Professor at Charisma University where he currently
                               lectures Master of Laws (LL.M) students in Conflict Resolution and Communication
                                and Theory in Conflict Resolution. Dr. Todd also lectures LL. B students at the
                                 said University in the areas of Legal system and Constitutional Law.
                              Dr. Todd has received several outstanding awards: Commander of the Most 
                              Distinguished Order of Special Envoy (CDSE), Commander of the Most Noble
                               Order of Global Peace Ambassadors (CGPA) Dean’s Scholars List award from
                                Charisma University (2019), Distinguished Alumni Award for Outstanding
                                 talent and profound work in law (Charisma University), Honorary Doctorate from 
                                 CICA International University & Seminary Houston Texas.
                              He is a certified Mediator and international Arbitrator and holds a certificate
                               in Judicial Mediation and Arbitration from the University of West Indies. 
                               Dr. Todd is the managing partner of Dexter Todd & Associates Law Firm and the
                                CEO of Todd’s Corporate Services Inc.`
    },
    {
        id: 8,
        name: 'Dr. Dahiru Muhammad Sani',
        image: '/images/sani.jpg',
        role: 'Director Legal Affairs (Africa)',
        description: `Dr. Dahiru Muhammad Sani is a seasoned university lecturer with a strong
                      track record in the education management industry. With 15 years of 
                      experience, Dr. Dahiru Muhammad Sani has honed a diverse skill set, 
                      including English-Hausa translation, journalism, radio broadcasting, 
                      academic writing, and magazine publication. An accomplished education 
                      professional, Dr. Dahiru Muhammad Sani holds a Master of Laws (LL.M) with 
                      a specialization in International Commercial Arbitration and a PhD in Law 
                      of Liabilities and Compensation from Ahmadu Bello University.`
    },
    {
        id: 5,
        name: 'Chief Augustine Nkwugbukansi Mgbemere',
        image: '/images/augustine.jpg',
        role: 'Director of Trade & Chairman, Committee on Trade',
        description: `A chartered accountant with over 40 years experience in both public and
                      private sectors, he holds bachelors of Economics degree from Obafemi Awolowo
                       University as well as professional qualifications from chartered Institute
                        of Taxation of Nigeria (CITN) and institute of Chartered Accountants of 
                        Nigeria (ICAN). Mr Mgbemere is the Managing Partner, Augustine N. Mgbemere & Co. Chartered
                        Accountants, MD/CEO, NESTINE Consult &Investment Ltd and has worked at the 
                        Abuja Chamber of Commerce as Director General, Messrs Francis Anokwu & Co
                      (Chartered Accountants), Tax
                      Consultants, Tax Practitioners and Management Consultant. Appointed controller
                       of branches at United Bank for AFrica with the responsibility of managing the
                        four branches of the bank. City Savings and Investment Bank Namibia with 
                        responsibility for developing the administration and operations manuals, 
                        internal control, accounting package, form designs, credit manuals and reporting 
                        formats also as Audit of MISR American Bank, Cairo EGYPT. Merchant Bank of Africa 
                        (Nig) Ltd  as Deputy Manager/ Chief Internal Auditor and rose to the position of 
                        Deputy General Manager/Head of Operation Division then As Chief Internal Auditor
                         of the Bank and Federal Board of Inland Revenue as Inspector of Taxes.`
    },
    {
        id: 6,
        name: 'Professor Nnamdi  Nwaodu',
        image: '/images/nnamdi.jfif',
        role: 'Director of Policy',
        description: `Professor Nnamdi  Nwaodu is a Professor of  International Relations, Department of International 
                      Relations and Strategic Studies, Igbinedion University, Okada, Edo State, Nigeria, his 
                      educational qualifications include, BSc Government and Public Administration,
                       MSc International Affairs and Diplomacy, MPA Masters in Public Administration,
                        MSc Industrial Sociology & Personnel Mgt ,MSc Development Studies, 
                        PhD International Relations. He has lectured at various Universities including
                         Abia state University, University of Fort Hare South Africa, school of 
                         Management, Information Technology and Governance, College of Law and 
                         Management Studies, University of Kwazulu- Natal, South Africa, University
                          of Jos, Imo state University, Micheal Okpara University Umudike, Centre 
                          for African-American Research Studies Abuja and Igbinedion University.
                           Professor Nwaodu is currently the Director General
                      of Centre for African-American Research Studies Nigeria/South Africa`
    },
    {
        id: 9,
        name: 'George Enema',
        image: '/images/geoge.jfif',
        role: 'Director Public Relations',
        description: `George Enema is a seasoned creative marketing and communications professional
                      with over 18 years of extensive experience in the advertising, information 
                      technology, and manufacturing sectors.
                      George possesses exceptional skills in business operations, brand building, 
                      and public, government, and external relations. He is recognized as a 
                      world-class business manager, having collaborated with major multinational 
                      companies across West Africa.
                     A passionate advocate of the African Renaissance, George leverages his vast 
                     experience and knowledge to champion the preservation and promotion of 
                     Africa's rich culture and heritage.
                     Before conceptualizing the gamification of language learning and spearheading
                      the development of MultiTrybze, George served as the Head of Marketing and
                       Corporate Communications at Transnational Corporation of Nigeria. Prior to
                        his tenure at Transcorp, he honed his cross-functional brand building and
                         management expertise at Unilever Plc, working across the 
                          (Fabcleaning), skincare, and food business categories.
                    Between 2009 and 2013, George was with IBM, where he led marketing 
                    communications, government, and external relations efforts.
                   George is also a Gallup Certified Strengths Coach, deeply committed to a
                    purpose-driven life. His personal mission is to "Unleash the Potential of
                     Young Adults to Evolve a More Productive Society.`
    },
]